<template>
  <modal-template
    ref="modal"
    modal-size="sm"
    :title="$t('shared.puzzle.sendTitle')"
    type-modal="send_hunting_words_modal"
  >
    <div class="modal-content__main send-to-site-modal">
      <p class="mb-3">
        {{ $t('huntingWordsGenerator.sendModal.description') }}
      </p>

      <d-form-checkbox
        v-if="children.length > 0"
        :checked="selectAll"
        :indeterminate="isIndeterminate"
        @change="toggleSelectAll"
        class="mb-2 font-weight-bold"
      >
        {{ $t('huntingWordsGenerator.sendModal.selectAll') }}
      </d-form-checkbox>

      <div
        v-if="children.length > 0"
        class="send-to-site-modal__list"
        :style="listStyle"
      >
        <d-form-checkbox
          v-for="(child, index) in children"
          :key="child.id"
          v-model="selectedIds"
          :value="child.id"
          class="mb-1"
        >
          {{ childLabel(child, index) }}
        </d-form-checkbox>
      </div>

      <p v-if="children.length === 0" class="text-muted mb-0">
        {{ $t('huntingWordsGenerator.sendModal.noChildren') }}
      </p>
    </div>

    <div slot="actions" class="modal-content__control">
      <d-button
        type="button"
        @click="onCancel"
        class="btn btn-sm btn-secondary mr-2"
      >
        {{ $t('shared.actions.cancel') }}
      </d-button>
      <d-button
        type="button"
        @click="onConfirm"
        class="btn btn-sm btn-primary"
        :disabled="selectedIds.length === 0"
      >
        {{ $t('shared.actions.send') }}
      </d-button>
    </div>
  </modal-template>
</template>

<script>
import { mapActions } from 'vuex';
import ModalTemplate from '_shared/Modal.vue';

export default {
  name: 'send-to-site-modal',
  components: {
    ModalTemplate,
  },
  props: {
    children: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedIds: [],
      listStyle: {
        maxHeight: '50vh',
        overflowY: 'scroll',
        overflowX: 'hidden',
      },
    };
  },
  computed: {
    isActive() {
      return this.$store.state.toggle.send_hunting_words_modal;
    },
    selectAll() {
      return (
        this.children.length > 0 &&
        this.selectedIds.length === this.children.length
      );
    },
    isIndeterminate() {
      return (
        this.selectedIds.length > 0 &&
        this.selectedIds.length < this.children.length
      );
    },
  },
  watch: {
    isActive(active) {
      if (active) {
        this.resetSelection();
      }
    },
    children() {
      if (this.isActive) {
        this.resetSelection();
      }
    },
  },
  methods: {
    ...mapActions(['setToggle', 'activeAlert']),
    childLabel(child, index) {
      if (child.name) {
        return child.name;
      }

      return this.$t('huntingWordsGenerator.form.game', { n: index + 1 });
    },
    resetSelection() {
      this.selectedIds = this.children.map(child => child.id);
    },
    toggleSelectAll(checked) {
      if (checked) {
        this.selectedIds = this.children.map(child => child.id);
      } else {
        this.selectedIds = [];
      }
    },
    onCancel() {
      this.setToggle({ type: 'send_hunting_words_modal', bool: false });
    },
    onConfirm() {
      if (this.selectedIds.length === 0) {
        this.activeAlert({
          message: this.$t('shared.puzzle.noSelected'),
          theme: 'warning',
        });
        return;
      }

      this.setToggle({ type: 'send_hunting_words_modal', bool: false });
      this.$emit('confirm', { ids: [...this.selectedIds] });
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-content__control {
  display: flex;
  justify-content: flex-end;
}

.send-to-site-modal__list {
  border: 1px solid #e1e5eb;
  border-radius: 0.25rem;
  padding: 0.5rem 0.75rem;
  -webkit-overflow-scrolling: touch;
}
</style>
